exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2Bvr7{width:100%;padding-top:15px;padding-bottom:15px}", ""]);

// exports
exports.locals = {
	"wrapper": "_2Bvr7"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-rules-2!./node_modules/postcss-loader/lib??ref--2-rules-3!./node_modules/sass-loader/lib/loader.js??ref--2-rules-4!./src/components/FormManager/FormManager.css
// module id = 1366
// module chunks = 0 1 2 3 5